import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import styles from "./styles.module.scss";

export const AuthFormFields = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["form-fields"]}>
      <FormInput
        placeholder={t("logInPage.phoneNumber")}
        name="username"
        className={styles["auth-input"]}
      />
      <FormInputPassword
        placeholder={t("logInPage.password")}
        name="password"
        className={styles["auth-input"]}
      />
    </div>
  );
};
